{
  "dropzoneLabel": "Bırakma Bölgesi",
  "selectPlaceholder": "Bir öğe seçin",
  "tableResizer": "Yeniden boyutlandırıcı",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
